/* eslint-disable @typescript-eslint/no-explicit-any */
import { useFormik, FormikProvider } from 'formik';
import * as Yup from 'yup';
import ButtonWithLoader from '../../../../common/components/ui/loading/ButtonLoading';
import { maskCPF, maskPhone, maskCNPJ } from '../../../../common/helpers/mask.helpers';
import InputFormik from '../../../../common/components/form/InputFormik';
import ComboBoxFormik from '../../../../common/components/form/ComboBoxFormik';
import { useState } from 'react';

type FormProps = {
  onSubmit: (values: any) => Promise<{ ok: boolean, errors?: unknown[] }>;
  data: any;
  formRequestErrors?: { message: string, path: string[] }[];
};

const validationSchema = Yup.object({
  cpf: Yup.string().required('O CPF é obrigatório.'),
  pixKeyType: Yup.string().required('O tipo de chave Pix é obrigatório.'),
  pixKey: Yup.string().required('A chave Pix é obrigatória.'),
});

function FormCollector(props: FormProps) {
  const [keyType, setKeyType] = useState('-');

  const handleKeyTypeChange = (value: unknown) => {
    if (typeof value === 'string') {
      setKeyType(value);
      formik.setFieldValue('pixKeyType', value);
    }
  };

  const getMaskFunction = () => {
    switch (keyType) {
      case "CPF":
        return maskCPF;
      case "Número de Telefone":
        return maskPhone;
      case "CNPJ":
        return maskCNPJ;
      default:
        return undefined;
    }
  };

  const formik = useFormik({
    initialValues: {
      cpf: props.data?.cpf || '',
      pixKeyType: props.data?.pixKeyType || '-',
      pixKey: props.data?.pixKey || '',
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (data) => {
      const result = await props.onSubmit(data);
      if (result.ok) {
        formik.resetForm();
      }
      return result;
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <FormikProvider value={formik}>
        <section>
          <div className="grid grid-cols-3 gap-2 mb-10">
            <div className="grid grid-cols-1 text-sm lg:text-lg col-span-3 gap-2">
              <div className="col-span-3">
                <InputFormik
                  label="CPF:"
                  name="cpf"
                  placeholder="111.222.333-44"
                  required={true}
                  mask={maskCPF}
                />
              </div>
              <div className="col-span-3 mt-4">
                <span className="text-md font-semibold text-gray-500">Dados para Pagamento:</span>
              </div>
              <div className="col-span-3">
                <ComboBoxFormik
                  name="pixKeyType"
                  label="Tipo de chave Pix:"
                  options={[
                    { value: "-", label: "-" },
                    { value: "CPF", label: "CPF" },
                    { value: "CNPJ", label: "CNPJ" },
                    { value: "Email", label: "Email" },
                    { value: "Número de Telefone", label: "Número de Telefone" },
                    { value: "Chave Aleatória", label: "Chave Aleatória" },
                  ]}
                  onChange={handleKeyTypeChange}
                  required={true}
                />
              </div>
              <div className="col-span-3">
                <InputFormik
                  label="Digite a chave do Pix:"
                  name="pixKey"
                  mask={getMaskFunction()}
                  required={true}
                />
              </div>
            </div>
          </div>
        </section>
        <div className="w-full flex justify-end">
          <ButtonWithLoader isLoading={formik.isSubmitting} disabled={!formik.isValid} onClick={formik.handleSubmit}>
            Salvar
          </ButtonWithLoader>
        </div>
      </FormikProvider>
    </form>
  );
}

export default FormCollector;
